'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _ListItem = require('./ListItem');var _ListItem2 = _interopRequireDefault(_ListItem);
var _AnchorList = require('./AnchorList.scss');var styles = _interopRequireWildcard(_AnchorList);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

// NOTE do not use as a plain component
var AnchorList = function (_Component) {_inherits(AnchorList, _Component);function AnchorList() {var _temp, _this, _ret;_classCallCheck(this, AnchorList);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      active: __CLIENT__ && !!location.hash && location.hash.slice(1) }, _this.


    setActive = function (key) {
      if (global && global.history) {
        var urlWithHash = location.pathname + location.search + (key ? '#' + key : '');
        _this.setState(
        { active: key },
        // Warning: can cause history state management bugs
        function () {
          global.history.replaceState(null, null, urlWithHash);
          if (_this.props.onSelectionChange) {
            _this.props.onSelectionChange(key);
          }
          setTimeout(function () {return _reactScroll.scroller.scrollTo(key, { smooth: true, offset: -50 });}, 200);
        });

      }
    }, _this.

    renderListItem = function (data) {
      var ListComponent = _this.props.listComponent || _ListItem2.default;
      var isActive = _this.state.active === data.key;
      var onClose = function onClose() {
        if (isActive) {setTimeout(_this.setActive(''), 100);}
      };
      var onOpen = function onOpen() {
        _this.setActive(data.key);
      };
      var afterInitialOpen = isActive ?
      function () {setTimeout(_reactScroll.scroller.scrollTo(data.key, { smooth: true, offset: -50 }), 100);} :
      null;

      return (
        _react2.default.createElement('li', { key: data.key, className: styles.wrapper },
          _react2.default.createElement(_reactScroll.Element, { name: data.key },
            _react2.default.createElement(ListComponent, _extends({},
            data, {
              isActive: isActive,
              className: (0, _classnames2.default)(styles.accordion, _this.props.listComponentClassName),
              onOpen: onOpen,
              onClose: onClose,
              afterInitialOpen: afterInitialOpen,
              content: _this.localRequire[_this.props.locale]('./' + data.fileName) })))));




    }, _temp), _possibleConstructorReturn(_this, _ret);}AnchorList.prototype.

  render = function render() {
    if (!__CLIENT__) {
      return null;
    }
    return (
      _react2.default.createElement('ul', { className: (0, _classnames2.default)(styles.anchorList, this.props.className) },
        this.props.children,
        this.props.dataList.map(this.renderListItem)));


  };return AnchorList;}(_react.Component);exports.default = AnchorList;


AnchorList.propTypes = {
  dataList: _propTypes2.default.array.isRequired,
  listComponent: _propTypes2.default.node,
  locale: _propTypes2.default.string,
  className: _propTypes2.default.string,
  listComponentClassName: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([
  _propTypes2.default.arrayOf(_propTypes2.default.node),
  _propTypes2.default.node]),

  onSelectionChange: _propTypes2.default.func };


AnchorList.defaultProps = {
  children: [] };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AnchorList/AnchorList.js
// module id = 1192
// module chunks = 0